import { NoticeRepository } from '../Repositories/NoticeRepository';

export class DeleteNoticeUseCase {
  constructor(private repo: NoticeRepository) {}
  execute(id: number): Promise<void> {
    return this.repo.delete(id).then(() => undefined).catch(err => Promise.reject(err));
  }
}
